__turbopack_context__.v({
  "acceptAllButton": "pBdQgW_acceptAllButton",
  "alwaysOn": "pBdQgW_alwaysOn",
  "categories": "pBdQgW_categories",
  "category": "pBdQgW_category",
  "categoryDescription": "pBdQgW_categoryDescription",
  "categoryHeader": "pBdQgW_categoryHeader",
  "categoryLabel": "pBdQgW_categoryLabel",
  "categoryName": "pBdQgW_categoryName",
  "closeButton": "pBdQgW_closeButton",
  "description": "pBdQgW_description",
  "fadeIn": "pBdQgW_fadeIn",
  "footer": "pBdQgW_footer",
  "header": "pBdQgW_header",
  "modal": "pBdQgW_modal",
  "overlay": "pBdQgW_overlay",
  "policyLink": "pBdQgW_policyLink",
  "saveButton": "pBdQgW_saveButton",
  "scaleIn": "pBdQgW_scaleIn",
  "title": "pBdQgW_title",
  "toggle": "pBdQgW_toggle",
  "toggleDisabled": "pBdQgW_toggleDisabled",
  "toggleOff": "pBdQgW_toggleOff",
  "toggleOn": "pBdQgW_toggleOn",
  "toggleThumb": "pBdQgW_toggleThumb",
  "toggleWrapper": "pBdQgW_toggleWrapper",
});
